import {useNavigation} from '@react-navigation/native';

export const useSafeNavigation = () => {
  try {
    return useNavigation();
  } catch {
    return null;
  }
};
